import { ChangeEvent, forwardRef, useImperativeHandle, useRef } from 'react';
import Telecom from 'src/components/join/Telecom';
import { InputStyled } from 'src/styles/common';
import styled from 'styled-components';

const PhoneNumberInput = styled(InputStyled)`
  margin: 10px 0;
`;

export interface PhoneNumberCertificationProp {
  phoneNumber: string;
  phoneNumberClassName?: string;
  focusOption?: FocusOptions;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onDisabled: boolean;
  onSubmit: () => void;
  onFocus?: () => void;
}

const PhoneNumberCertification = forwardRef((props: PhoneNumberCertificationProp, ref) => {
  const { phoneNumber, phoneNumberClassName, focusOption, onChange, onDisabled, onSubmit, onFocus } = props;
  const phoneNumberRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => {
    return phoneNumberRef.current;
  }, []);

  const handleTelecomClick = () => {
    phoneNumberRef.current?.focus(focusOption);
    if (onFocus) {
      onFocus();
    }
  };

  const handlePhoneNumberClick = () => {
    if (onFocus) {
      setTimeout(() => onFocus(), 100);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') onSubmit();
  };

  return (
    <>
      <Telecom onClick={handleTelecomClick} />
      <PhoneNumberInput
        ref={phoneNumberRef}
        type="tel"
        placeholder="휴대폰번호를 입력하세요."
        value={phoneNumber}
        className={phoneNumberClassName}
        onChange={onChange}
        disabled={onDisabled}
        maxLength={11}
        onKeyDown={handleKeyDown}
        onClick={handlePhoneNumberClick}
      />
    </>
  );
});

export default PhoneNumberCertification;
